import axios from 'axios'

const state = {
  refund: {},
  orderMsg: {} ///修改订单的数据
}

const mutations = {
  setRefund (state, data) {
    state.refund = data
  },
  setOrderMsg (state, data) {
    state.orderMsg = data
  }
}

const getters = {
  getRefund: state => {
    return state.refund
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
